<template>
  <div id="questions">
    <headNav>
      <div slot="headNavText">{{title}}</div>
    </headNav>
    <div class="container">
      <div style="padding: 15px;background-color: rgb(249,248,248);box-sizing: border-box;border-radius: 5px;margin:10px">
<!--        <div class="title1" style="text-align: center;font-size: 18px;font-weight: 500;padding-bottom: 15px">{{title}}</div>-->
        <div v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import headNav from "../HeadNav/headNav";
  import {customer_tel} from '../../ports/port'
  export default {
    name: "gonggao",
    data() {
      return {
        title:'',
        content:''
      }
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      this.title = this.$route.query.title;
      this.content = this.escape2Html(this.$route.query.content);
    },
    components: {
      headNav
    },
    methods:{
      //转义后端通过富文本传过来的，含有&quot等
      escape2Html(str) {
        var arrEntities={'lt':'<','gt':'>','nbsp':' ','amp':'&','quot':'"'};
        return str.replace(/&(lt|gt|nbsp|amp|quot);/ig,function(all,t){
          return arrEntities[t];
        });
      }
    }
  }
</script>

<style scoped lang="scss">
  @media (min-width:1430px) {
    #questions {
      padding: 70px 30px;
      .container {

      }
    }
  }
  @media (max-width:1430px) {
    #questions {
      padding: 1.4rem 0.3rem;
      .container {
        h1 {
          font-size: 0.53rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/gonggao.vue